const EXCLUDED_CHAIN_PATTERNS = [
  // 现制饮品连锁
  /蜜雪冰城/,
  /瑞幸咖啡/,
  /星巴克/,
  /库迪咖啡/,
  /喜茶/,
  /奈雪的茶/,
  /霸王茶姬/,
  /茶百道/,
  /书亦烧仙草/,
  /古茗/,
  /沪上阿姨/,
  /益禾堂/,
  /一点点/,
  /coco/i,
  /甜啦啦/,
  /幸运咖/,
  /挪瓦咖啡/,
  /manner/i,
  /mstand/i,
  /tims/i,
  /皮爷咖啡/,
  /一只酸奶牛/,
  /兵立王/,
  /柠季/,
  /茉酸奶/,
  /茶话弄/,
  /7分甜/,
  /茶颜悦色/,
  /新时沏/,
  // 快餐与标准化餐饮连锁
  /麦当劳/,
  /肯德基/,
  /德克士/,
  /华莱士/,
  /必胜客/,
  /塔斯汀/,
  /汉堡王/,
  /赛百味/,
  /老乡鸡/,
  /乡村基/,
  /大米先生/,
  /杨国福/,
  /张亮麻辣烫/,
  /正新鸡排/,
  /绝味鸭脖/,
  /周黑鸭/
];

// 城市商场店与标准化门店：做“周末出去玩”清单时默认排除，
// 用户仍可在“全部数据库”里手动关掉这层过滤。
const CITY_STYLE_CATEGORIES = new Set([
  "茶饮果汁",
  "快餐简餐",
  "美食城",
  "经济型",
  "便利店",
  "面包烘焙"
]);

const CITY_MALL_PATTERN =
  /(万象城|万达广场|龙湖天街|大悦城|来福士|银泰|凯德|印象城|环球中心|IFS|国金中心|伊藤洋华堂|山姆会员|盒马|永辉|家乐福)/i;

export function isExcludedShopName(name) {
  return EXCLUDED_CHAIN_PATTERNS.some((pattern) => pattern.test(name ?? ""));
}

export function isCityStyleShop(shop) {
  const name = shop?.name ?? "";
  if (isExcludedShopName(name)) return true;
  const category = String(shop?.category ?? shop?.cuisine ?? "").trim();
  if (CITY_STYLE_CATEGORIES.has(category)) return true;
  return CITY_MALL_PATTERN.test(name);
}

export function qualityTierForShop(shop) {
  return shop.reviewSnapshot && shop.image ? "rich" : "indexed";
}
